/**
 * Centralized environment configuration.
 * All VITE_* env vars are loaded here and exposed as a typed object.
 */
export interface AppEnv {
  apiBaseUrl: string;
  appVersion: string;
  faceDescriptorType: string;
}

const raw = (import.meta as unknown as { env: Record<string, string | undefined> }).env;

export const env: AppEnv = {
  apiBaseUrl: raw.VITE_API_BASE_URL ?? '/api/v1',
  appVersion: raw.VITE_APP_VERSION ?? '0.1.0',
  faceDescriptorType: raw.VITE_FACE_DESCRIPTOR_TYPE ?? 'FACIAL_EMBEDDING_128',
};

export default env;
